export const SET_SUB_MENU = 'SET_SUB_MENU'
export const SET_SUB_MENU_V2 = 'SET_SUB_MENU_V2'
export const SET_MAIN_MENU = 'SET_MAIN_MENU'
